jQuery(function ($) {
    const numberFormat = new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const ORDER_TYPE_FULL_PRODUCT = 2;
    var addToCartButton = $('[name="add-to-cart"]');
    var lengthSelector = '[data-product-length]';
    var widthSelector = '[data-product-width]';
    var weightSelector = '[data-product-weight]';
    let errors = {};

    // First with value set
    let length = $('[data-product-calculator]').data('shippingLength');
    let width = $('[data-product-calculator]').data('shippingWidth');

    if ($(lengthSelector).length > 0) {
        length = $(lengthSelector).val();
    }

    if ($(widthSelector).length > 0) {
        width = $(widthSelector).val();
    }

    if (parseInt(length) > 0 || parseInt(width) > 0) {
        updatePrice($('[data-product-calculator]'));
    }

    $(document)
        .on('quantity-change', function (e, data) {
            updatePrice($(data.source).closest('[data-product-calculator]'))
        })
        .on('change keyup', '[data-product-calculator] input:not(.qty,[name*="[order_type]"]), [data-product-calculator] select, [data-product-calculator] textarea', function () {
            updatePrice($(this).closest('[data-product-calculator]'));
        })
        .on('change keyup', '[data-product-calculator] input[name*="[order_type]"]', function () {
            var value = parseInt($(this).val(), 10);
            var calculator = $(this).closest('[data-product-calculator]');
            var lengthField = calculator.find(lengthSelector)
            var widthField = calculator.find(widthSelector)

            if (value === ORDER_TYPE_FULL_PRODUCT) {
                calculator.find('[data-dimension-field]').addClass('!hidden');

                lengthField.data('oldValue', lengthField.val())
                    .val(lengthField.attr('max'));
                widthField.data('oldValue', widthField.val())
                    .val(widthField.attr('max'));
            } else {
                calculator.find('[data-dimension-field]').removeClass('!hidden');

                lengthField.val(lengthField.data('oldValue'));
                widthField.val(widthField.data('oldValue'));
            }

            updatePrice($(this).closest('[data-product-calculator]'));
        })
        .on('click', '[data-product-calculator] [data-remove]', function () {
            $(this).closest('[data-product-calculator]').remove();

            updateTotalPrice();
        })
        .on('variation.update', (e, data) => {
            const setProductHolder = data.product.find('[data-custom-set-products]');

            setProductHolder.removeClass('hidden');

            const setProductContentHolder = setProductHolder.find('[data-custom-set-products-content]');
            setProductContentHolder.html('');

            data.variation.products.forEach((variationProduct) => {
                const row = $('<div>')
                    .addClass([
                        'grid',
                        'grid-cols-8',
                        'gap-2',
                        'p-1.5',
                        'border',
                        'border-t-0',
                        'border-blue',
                    ])

                // Thumbnail
                $('<div>')
                    .addClass([
                        'col-span-1',
                    ])
                    .append(
                        variationProduct.thumbnail
                    )
                    .appendTo(row)

                // Quantity
                $('<div>')
                    .addClass([
                        'text-right',
                        'col-span-1',
                        'text-sm',
                    ])
                    .html(
                        variationProduct.quantity + 'x'
                    )
                    .appendTo(row)

                // Product name
                $('<div>')
                    .addClass([
                        'col-span-4',
                        'md:col-span-3',
                        'text-sm',
                        'leading-5',
                    ])
                    .append(
                        $('<strong>').html(variationProduct.name)
                    )
                    .appendTo(row)

                // Total price
                let price = '';

                if (variationProduct.show_price) {
                    price = $('<strong>').html(display_price(variationProduct.total_price));
                }

                $('<div>')
                    .addClass([
                        'text-right',
                        'text-sm',
                        'col-span-2',
                        'md:col-span-3',
                    ])
                    .append(price)
                    .appendTo(row)

                row.appendTo(setProductContentHolder);
            })
        })
        .on('click', '[data-custom-set-products-header]', function (e) {
            e.stopPropagation();

            $(this)
                .closest('[data-custom-set-products]')
                .toggleClass('open');
        })

    $('[data-add-row]').click(function (e) {
        e.preventDefault();

        var calculator = $('[data-product-calculator]');
        var nextIndex = calculator.length + 1;
        var productCalculator = calculator.first().clone().prop('outerHTML');

        productCalculator = productCalculator.replace(/product_([0-9]+)_/g, 'product_' + nextIndex + '_')
        productCalculator = productCalculator.replace(/product\[([0-9]+)\]/g, 'product[' + nextIndex + ']');

        $('[data-product-calculator]:last').after(productCalculator)

        const newProductCalculator = $('[data-product-calculator]:last');
        newProductCalculator.find('.invalid-message').remove()

        newProductCalculator.find(lengthSelector).val('')
        newProductCalculator.find(widthSelector).val('')

        // Reset element price
        buildProductPrice(
            newProductCalculator.data('priceIncl'),
            newProductCalculator.data('priceExcl'),
            newProductCalculator,
            newProductCalculator.data('priceRegularExcl'),
            newProductCalculator.data('priceRegularIncl'),
        );

        $('<a>')
            .attr({
                href: 'javascript:void(0);',
                'data-remove': '',
                'style': 'padding: 0.2rem;border-radius: 9999px;'
            })
            .addClass('rounded-full btn btn-blue absolute top-2 right-2 w-6 h-6 p-3')
            .html('<svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full transform rotate-45" viewBox="0 0 27.001 27"><g id="Group_173" data-name="Group 173" transform="translate(-124.469 -100.708)"><path id="Path_93" data-name="Path 93" d="M137.49,127.708c-.018-.078-.093-.077-.145-.091a2.462,2.462,0,0,1-1.8-2.512c.012-2.594,0-5.188,0-7.781,0-.577-.13-.7-.716-.7h-7.781a2.6,2.6,0,0,1-1.813-.648,2.374,2.374,0,0,1-.613-2.6,2.286,2.286,0,0,1,1.957-1.545,6.108,6.108,0,0,1,.842-.036h7.438c.545,0,.685-.139.685-.682q0-3.9,0-7.808a2.592,2.592,0,0,1,.61-1.774,2.42,2.42,0,0,1,2.54-.7,2.392,2.392,0,0,1,1.651,2.019c.025.255.033.508.033.763q0,3.746,0,7.491c0,.559.135.692.7.692q3.9,0,7.808,0a2.521,2.521,0,0,1,1.768.623,2.416,2.416,0,0,1,.7,1.094c.029.1.027.2.111.277v.9c-.112.068-.1.194-.136.3a2.385,2.385,0,0,1-.672,1.019,2.54,2.54,0,0,1-1.792.627h-7.777c-.581,0-.711.129-.711.708q0,3.9,0,7.8a2.5,2.5,0,0,1-.991,2.106,4.033,4.033,0,0,1-1.056.472Z" fill="#fff"></path></g></svg>')
            .appendTo(newProductCalculator.find('> div'));

        // Hide set products
        newProductCalculator
            .find('[data-custom-set-products]')
            .addClass('hidden')
            .removeClass('open')
            .find('[data-custom-set-products-content]')
            .html('');
    })

    $('form.cart').submit(function (e) {
        if ($('input[name^="product[1]"]').length === 0) {
            return;
        }

        e.preventDefault()

        var button = $(this).find('[name=add-to-cart]');
        var data = $(this).serializeArray();

        data.push({
            name: 'product_id',
            value: button.val()
        })

        data.push({
            name: 'action',
            value: 'woocommerce_ajax_add_to_cart'
        })

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function () {
                button.addClass('loading')
                    .prop('disabled', true)
            },
            complete: function (response) {
                button.removeClass('loading')
                    .prop('disabled', false)
            },
            success: function (response) {
                if (response.hasOwnProperty('error') && response.error) {
                    parseErrors(response.errors)
                } else {
                    if (typeof fbq !== 'undefined') {
                        $('[data-total-price-incl]').each(function () {
                            fbq('track', 'AddToCart', {
                                value: $(this).data('totalPriceIncl'),
                                currency: 'EUR',
                                content_name: $('h1.product_title').html(),
                                content_ids: [button.val()],
                                content_type: 'product',
                            });
                        });
                    }

                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    }

                    // Redirect to cart option
                    if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                        window.location = wc_add_to_cart_params.cart_url;
                        return;
                    }

                    // Trigger event so themes can refresh other areas.
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                }
            }
        });
    })

    function isValid(product) {
        let valid = true;
        let isDimension = product.is('[data-dimensions]');
        let isCustomSet = product.is('[data-plexiglas-custom-set]');
        let isLength = product.is('[data-length]');
        let productIndex = product.index() + 1;

        if (!errors.hasOwnProperty(productIndex)) {
            errors[productIndex] = {};
        }

        if ((isDimension || isLength || isCustomSet) && !validateDimensionField(product.find(lengthSelector), productIndex)) {
            valid = false;
        }
        product.find(lengthSelector).data('is-valid', valid)

        if ((isDimension || isCustomSet) && !validateDimensionField(product.find(widthSelector), productIndex)) {
            valid = false;
        }
        product.find(widthSelector).data('is-valid', valid)

        // Validate required fields
        product.find('[data-required="1"]').each(function () {
            let optionKey = $(this).data('option');
            let input = null;

            if (isDimension || isLength || isCustomSet) {
                input = $('[name="product[' + productIndex + '][' + optionKey + ']"]');
            } else {
                input = $('[name="' + optionKey + '"]');
            }

            if (!errors[productIndex].hasOwnProperty(optionKey)) {
                errors[productIndex][optionKey] = [];
            }

            switch ($(this).data('optionType')) {
                case 'radio':
                case 'checkbox':
                    if (input.filter(':checked').val() === undefined) {
                        valid = false;

                        errors[productIndex][optionKey].push('Dit veld is verplicht');
                    }
                    break;
                case 'select':
                    if (input.find('option:selected').length < 1) {
                        valid = false;

                        errors[productIndex][optionKey].push('Dit veld is verplicht');
                    }
                    break;
                default:
                    if (input.val() === '') {
                        valid = false;

                        errors[productIndex][optionKey].push('Dit veld is verplicht');
                    }

                    break;
            }
        });

        // Validate measurement fields
        product.find('[data-option-type="measurement"]').each(function () {
            let optionKey = $(this).data('option');
            let input = null;

            if (isDimension || isLength || isCustomSet) {
                input = $('[name="product[' + productIndex + '][' + optionKey + ']"]');
            } else {
                input = $('[name="' + optionKey + '"]');
            }

            if (!errors[productIndex].hasOwnProperty(optionKey)) {
                errors[productIndex][optionKey] = [];
            }

            // Required validation is already done
            if ($(this).data('required') === 1 && input.val() === '') {
                return;
            }

            var value = convertUnitValue(
                input.val(),
                input.data('inputUnit'),
                input.data('outputUnit')
            )

            var minValue = null;
            var maxValue = null;

            input.data('measures').forEach((measure) => {
                if (minValue === null || measure.from < minValue) {
                    minValue = measure.from
                }

                if (maxValue === null || measure.till > maxValue) {
                    maxValue = measure.till
                }
            })

            if (value < minValue) {
                valid = false;

                var unit = convertUnitValue(
                    minValue,
                    input.data('outputUnit'),
                    input.data('inputUnit')
                )

                errors[productIndex][optionKey].push('De minimale waarde is ' + unit + ' ' + input.data('inputUnit'));
            }

            if (value > maxValue) {
                valid = false;

                var unit = convertUnitValue(
                    maxValue,
                    input.data('outputUnit'),
                    input.data('inputUnit')
                )

                errors[productIndex][optionKey].push('De maximale waarde is ' + unit + ' ' + input.data('inputUnit'));
            }
        })

        return valid;
    }

    function validateDimensionField(field, productIndex) {
        var value = convertFloat(field.val());
        var fieldName = field.is('[data-product-length]') ? 'length' : 'width';
        var min = convertFloat(field.attr('min'));
        var max = convertFloat(field.attr('max'));
        var inputUnit = field.data('inputUnit');

        if (!errors.hasOwnProperty(errors[productIndex][fieldName])) {
            errors[productIndex][fieldName] = [];
        }

        if (!value) {
            return false;
        }

        if (isNaN(value)) {
            errors[productIndex][fieldName].push('Geen geldig getal opgegeven');

            return false;
        }

        if (value < min) {
            errors[productIndex][fieldName].push('De minimale waarde is ' + min + ' ' + inputUnit);

            return false;
        }

        if (max && value > max) {
            errors[productIndex][fieldName].push('De maximale waarde is ' + max + ' ' + inputUnit);

            return false;
        }

        return true;
    }

    function removeErrorMessages(element = null) {
        if (element) {
            element.find('.invalid-message').remove();
        } else {
            $('.invalid-message').remove();
        }
    }

    function parseErrors(errors) {
        const isDimensions = $('[data-dimensions]').length > 0;
        const isCustomSet = $('[data-plexiglas-custom-set]').length > 0;
        const isLength = $('[data-length]').length > 0;

        removeErrorMessages()

        $.each(errors, function (id, messages) {
            $.each(messages, function (key, message) {
                var errorElement = $('<span>').addClass('invalid-message block')
                    .html(message)

                if (key === 'length' && (isDimensions || isLength || isCustomSet)) {
                    errorElement.insertAfter($('#productLengthContainer'));
                    return;
                }

                if (key === 'width' && (isDimensions || isCustomSet)) {
                    errorElement.insertAfter($('#productWidthContainer'));
                    return;
                }

                if (isDimensions || isLength || isCustomSet) {
                    errorElement.appendTo(
                        $('[name="product[' + id + '][' + key + ']"]').closest('.form-row')
                    )
                } else {
                    errorElement.appendTo(
                        $('[name="' + key + '"]').closest('.form-row')
                    )
                }
            })
        })
    }

    function buildProductPrice(priceIncl, priceExcl, element, totalPriceRegularExcl, totalPriceRegularIncl) {
        priceIncl = numberFormat.format(priceIncl).split(',')
        priceExcl = numberFormat.format(priceExcl).split(',')

        element.find('[data-total-price-excl]')
            .attr('data-total-price-excl', priceExcl[0] + '.' + priceExcl[1])
            .html('€' + priceExcl[0] + ',')
            .append(
                $('<span>').addClass('text-xl').html(priceExcl[1])
            )

        element.find('[data-total-price-incl]')
            .attr('data-total-price-incl', priceIncl)
            .html('€' + priceIncl[0] + ',' + priceIncl[1]);

        if (totalPriceRegularExcl) {
            totalPriceRegularExcl = numberFormat.format(totalPriceRegularExcl)
            totalPriceRegularIncl = numberFormat.format(totalPriceRegularIncl)

            element.find('[data-total-price-regular-excl]').html('€' + totalPriceRegularExcl);
            element.find('[data-total-price-regular-incl]').html('€' + totalPriceRegularIncl);
        }
    }

    function updateTotalPrice() {
        var totalIncl = 0;
        var totalExcl = 0;
        var totalRegularExcl = 0;
        var totalRegularIncl = 0;
        var totals = $('[data-totals]');

        $('[data-product-calculator]').each(function () {
            let priceIncl = $(this).data('total-price-incl')
            let priceExcl = $(this).data('total-price-excl')

            if (priceIncl === undefined || priceExcl === undefined) {
                return;
            }

            totalIncl += parseFloat(priceIncl)
            totalExcl += parseFloat(priceExcl)

            let priceRegularExcl = $(this).data('total-price-regular-excl')
            let priceRegularIncl = $(this).data('total-price-regular-incl')

            if (priceRegularExcl === undefined || priceRegularIncl === undefined) {
                return;
            }

            totalRegularExcl += parseFloat(priceRegularExcl)
            totalRegularIncl += parseFloat(priceRegularIncl)
        })

        totalIncl = numberFormat.format(totalIncl).split(',')
        totalExcl = numberFormat.format(totalExcl).split(',')

        totals
            .find('[data-price-excl]')
            .html('€' + totalExcl[0] + ',')
            .append($('<span>').addClass('text-xl').html(totalExcl[1]));

        totals
            .find('[data-price-incl]')
            .html('€' + totalIncl[0] + ',')
            .append($('<span>').html(totalIncl[1]));

        if (totalRegularExcl) {
            totalRegularExcl = numberFormat.format(totalRegularExcl)
            totalRegularIncl = numberFormat.format(totalRegularIncl)

            totals.find('[data-price-regular-excl]').html('€' + totalRegularExcl)
            totals.find('[data-price-regular-incl]').html('€' + totalRegularIncl)
        }
    }

    function updatePrice(product) {
        // Reset the errors
        errors = {};
        let allProductsValid = true

        $('[data-product-calculator]').not(product).each(function () {
            if (!isValid($(this)) || $(this).data('stockStatus') === 'outofstock') {
                parseErrors(errors);

                addToCartButton.prop('disabled', true);

                allProductsValid = false
            }
        })

        if (!isValid(product)) {
            parseErrors(errors);

            addToCartButton.prop('disabled', true);

            return;
        }

        removeErrorMessages(product);

        var quantity = parseInt(product.find('.qty').val());
        const taxRate = (product.data('taxRate') / 100) + 1;
        var priceExcl = parseFloat(product.data('priceExcl'));
        var priceIncl = (priceExcl * taxRate).toFixed(2);
        var priceRegularExcl = product.data('priceRegularExcl');
        var minPriceRegularExcl = product.data('minPriceRegularExcl');
        var priceRegularIncl = null;
        var minPriceExcl = parseFloat(product.data('minPriceExcl'));
        var minPriceIncl = minPriceExcl * taxRate;
        var length = false;
        var width = false;
        var lengthElement = product.find(lengthSelector)
        var weightElement = product.find(weightSelector)

        if (priceRegularExcl) {
            priceRegularExcl = parseFloat(priceRegularExcl);
        }

        if (minPriceRegularExcl) {
            minPriceRegularExcl = parseFloat(minPriceRegularExcl);
        }

        const shippingLength = convertUnitValue(
            product.data('shippingLength'),
            'cm',
            'm'
        );

        if (lengthElement.length > 0) {
            length = convertUnitValue(
                lengthElement.val(),
                lengthElement.data('inputUnit'),
                lengthElement.data('outputUnit')
            );
        }

        const shippingWidth = convertUnitValue(
            product.data('shippingWidth'),
            'cm',
            'm'
        );

        var widthElement = product.find(widthSelector)
        if (widthElement.length > 0) {
            width = convertUnitValue(
                widthElement.val(),
                widthElement.data('inputUnit'),
                widthElement.data('outputUnit')
            );
        }

        if (product.is('[data-plexiglas-custom-set]')) {
            const variations = product.data('variations').filter(value => width <= value.width && length <= value.length);

            // get the variation with the lowest length and width
            const variation = variations.reduce((prev, current) => {
                if (prev.length > current.length) {
                    return current;
                }

                if (prev.length === current.length && prev.width > current.width) {
                    return current;
                }

                return prev;
            });

            priceExcl = variation.price_excl;

            if (width != variation.width || length != variation.length) {
                priceExcl += variation.cut_price_excl;
            }

            $(document).trigger('variation.update', {
                product: product,
                variation: variation,
            })

            product.find('[data-variation-id]').val(variation.variation_id);
        } else {
            if (length && width) {
                priceExcl = priceExcl * (length * width)
                priceIncl = priceExcl * taxRate

                if (priceRegularExcl) {
                    priceRegularExcl = priceRegularExcl * (length * width)
                    priceRegularIncl = priceRegularExcl * taxRate
                }

                // If is dimension product calculate weight
                if (weightElement.length > 0) {
                    const surface = convertUnitValue(width, widthElement.data('outputUnit'), 'm') *
                        convertUnitValue(length, lengthElement.data('outputUnit'), 'm');
                    const weight = surface * parseFloat(weightElement.data('productWeight'));

                    weightElement.html(numberFormat.format(weight));
                }
            } else if (length && !width) {
                priceExcl = priceExcl * length;
                priceIncl = priceExcl * taxRate;

                if (priceRegularExcl) {
                    priceRegularExcl = priceRegularExcl * length
                    priceRegularIncl = priceRegularExcl * taxRate
                }
            }
        }

        if (priceExcl < minPriceExcl) {
            priceExcl = minPriceExcl
            priceIncl = minPriceIncl;
        }

        if (priceRegularExcl && priceRegularExcl < minPriceRegularExcl) {
            priceRegularExcl = minPriceRegularExcl
        }

        const optionLength = length ? length : shippingLength;
        const optionWidth = width ? width : shippingWidth;

        product.find('[data-option]').each(function () {
            switch ($(this).data('optionType')) {
                case 'radio':
                    var optionPrice = parseOptionRadio($(this), optionLength, optionWidth, product)

                    if (optionPrice) {
                        priceExcl += optionPrice.totalPriceExcl
                        priceIncl += priceExcl * taxRate
                    }
                    break;
                case 'measurement':
                    var optionPrice = parseOptionMeasurement($(this), optionLength, optionWidth, product)


                    if (optionPrice) {
                        priceExcl += optionPrice.totalPriceExcl
                        priceIncl += priceExcl * taxRate
                    }
                    break;
                case 'select':
                    var optionPrice = parseOptionSelect($(this), optionLength, optionWidth, product)

                    if (optionPrice) {
                        priceExcl += optionPrice.totalPriceExcl
                        priceIncl += priceExcl * taxRate
                    }
                    break;
                default:
                    var optionPrice = parseOptionText($(this), optionLength, optionWidth, product)

                    if (optionPrice) {
                        priceExcl += optionPrice.totalPriceExcl
                        priceIncl += priceExcl * taxRate
                    }
                    break;
            }
        });

        var totalPriceExcl = priceExcl * quantity
        var totalPriceIncl = totalPriceExcl * taxRate
        var totalPriceRegularExcl = null;
        var totalPriceRegularIncl = null;

        if (priceRegularExcl) {
            totalPriceRegularExcl = priceRegularExcl * quantity;
            totalPriceRegularIncl = totalPriceRegularExcl * taxRate;
        }

        buildProductPrice(totalPriceIncl, totalPriceExcl, product, totalPriceRegularExcl, totalPriceRegularIncl);
        product.data('total-price-incl', totalPriceIncl);
        product.data('total-price-excl', totalPriceExcl);
        product.data('total-price-regular-excl', totalPriceRegularExcl);
        product.data('total-price-regular-incl', totalPriceRegularIncl);

        updateTotalPrice();

        addToCartButton.prop('disabled', !allProductsValid || product.data('stockStatus') === 'outofstock');
    }

    function parseOptionRadio(option, length, width, product) {
        var totalPriceExcl = 0
        var totalPriceIncl = 0
        var isDimensions = length && width

        option.find('input[type=radio]').each(function () {
            var priceExcl = parseFloat($(this).data('priceExcl'))
            var priceIncl = parseFloat($(this).data('priceIncl'))
            var minimalPriceExcl = parseFloat($(this).data('minimalPriceExcl'))
            var minimalPriceIncl = parseFloat($(this).data('minimalPriceIncl'))
            var priceType = $(this).data('priceType')

            if (priceExcl === 0 || isNaN(priceExcl)) {
                return;
            }

            if (priceType === 'circumference' && isDimensions) {
                priceExcl = priceExcl * ((width * 2) + (length * 2))
                priceIncl = priceIncl * ((width * 2) + (length * 2))
            }

            if (priceExcl < minimalPriceExcl) {
                priceExcl = minimalPriceExcl
                priceIncl = minimalPriceIncl
            }

            option.find('[data-option-price]').html(display_price(priceExcl));

            if ($(this).prop('checked')) {
                totalPriceExcl += priceExcl
                totalPriceIncl += priceIncl
            }
        })

        return {
            totalPriceExcl: totalPriceExcl,
            totalPriceIncl: totalPriceIncl,
        };
    }

    function parseOptionMeasurement(option, length, width, product) {
        const taxRate = (product.data('taxRate') / 100) + 1;
        var field = option.find('input[type=text]');
        var value = convertUnitValue(
            field.val(),
            field.data('inputUnit'),
            field.data('outputUnit')
        );

        var currentMeasure = null;
        var label = option.find('.form-label');

        label.find('.note').remove();

        field.data('measures').forEach((measure) => {
            if (measure.from <= value && measure.till >= value) {
                currentMeasure = measure
            }
        })

        if (!currentMeasure || currentMeasure.price === 0) {
            return {
                totalPriceExcl: 0,
                totalPriceIncl: 0,
            };
        }

        let priceExcl = parseFloat(currentMeasure.price);
        let priceIncl = priceExcl * taxRate;

        // console.log(option.data('hidePrice'))
        if (!option.data('hidePrice')) {
            // Build price element
            $('<span>')
                .addClass('note')
                .html('<span class="font-normal not-italic">+ <span data-option-price="' + priceExcl + '"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">€</span>&nbsp;' + numberFormat.format(priceExcl) + '</bdi></span></span></span>')
                .appendTo(label)
        }

        return {
            totalPriceExcl: priceExcl,
            totalPriceIncl: priceIncl,
        };
    }

    function parseOptionSelect(option, length, width, product) {
        var totalPriceExcl = 0
        var totalPriceIncl = 0
        var isDimensions = length && width

        option.find('select option').each(function () {
            var priceExcl = parseFloat($(this).data('priceExcl'))
            var priceIncl = parseFloat($(this).data('priceIncl'))
            var minimalPriceExcl = parseFloat($(this).data('minimalPriceExcl'))
            var minimalPriceIncl = parseFloat($(this).data('minimalPriceIncl'))
            var priceType = $(this).data('priceType')

            if (priceExcl === 0) {
                return;
            }

            if (priceType === 'circumference' && isDimensions) {
                priceExcl = priceExcl * ((width * 2) + (length * 2))
                priceIncl = priceIncl * ((width * 2) + (length * 2))
            }

            if (priceExcl < minimalPriceExcl) {
                priceExcl = minimalPriceExcl
                priceIncl = minimalPriceIncl
            }

            $(this).html($(this).data('defaultLabel') + ' + ' + display_price(priceIncl));

            if ($(this).prop('selected')) {
                totalPriceExcl += priceExcl
                totalPriceIncl += priceIncl
            }
        })

        return {
            totalPriceExcl: totalPriceExcl,
            totalPriceIncl: totalPriceIncl,
        };
    }

    function parseOptionText(option, length, width, product) {
        var isDimensions = length && width
        const field = option.find('[data-price-incl]');
        const taxRate = (product.data('taxRate') / 100) + 1;

        if (!$.trim(field.val())) {
            return;
        }

        let totalPriceExcl = parseFloat(field.data('priceExcl'))
        let priceType = field.data('priceType')

        if (totalPriceExcl === 0) {
            return;
        }

        if (priceType === 'circumference' && isDimensions) {
            totalPriceExcl = totalPriceExcl * ((width * 2) + (length * 2))
        }

        const totalPriceIncl = totalPriceExcl * taxRate;

        option.find('[data-option-price]').html(display_price(totalPriceExcl))

        return {
            totalPriceExcl: totalPriceExcl,
            totalPriceIncl: totalPriceIncl,
        };
    }
});